import LegacyActionFactory from '../../../shared_components/LegacyActionFactory'

const OrganizationActions = new LegacyActionFactory([
  'GOT_ORGANIZATIONS'
])

OrganizationActions.buildBoundGet('organizations', 'organizations', OrganizationActions.Types.GOT_ORGANIZATIONS)

export default OrganizationActions
